import Swiper from "swiper";

export default function () {
  const companies = document.querySelectorAll('.customer-wins__slider-item');
  const infoSlides = document.querySelectorAll('.cases-stadies__slider');

  if (companies.length > 0) {
    let activeCompany,
      activeInfoSlider,
      infoSliderSwiper;

    function activateCompany(company) {
      if (activeCompany) {
        activeCompany.classList.remove('customer-wins__slider-item_active');
      }
      activeCompany = company;
      activeCompany.classList.add('customer-wins__slider-item_active');

      const companyInfoSlider = [].slice.call(infoSlides).find((element) => {
        return element.getAttribute('data-company-name') === company.getAttribute('data-company-name');
      });
      activateInfoSlider(companyInfoSlider);
    }

    function activateInfoSlider(infoSlider) {
      if (activeInfoSlider) {
        activeInfoSlider.classList.remove('cases-stadies__slider_active');
        if (infoSliderSwiper) {
          infoSliderSwiper.destroy(true, false);
        }
      }
      activeInfoSlider = infoSlider;
      activeInfoSlider.classList.add('cases-stadies__slider_active');
      if (infoSlider.querySelectorAll('.cases-stadies__slider-item').length > 1) {
        infoSliderSwiper = new Swiper(infoSlider, {
          slidesPerView: 1,
          autoHeight: true,
          pagination: {
            clickable: true,
            el: ".cases-stadies__slider-nav-pagination",
          }
        });
        activeInfoSlider.querySelector(".cases-stadies__slider-nav").classList.add("cases-stadies__slider-nav_active")
      }
    }

    companies.forEach((element) => {
      element.addEventListener('click', function () {
        activateCompany(this);
      });
    });

    function hideArrow() {
      const arrow = document.querySelector(".customer-wins__slider-nav");
      if (arrow.querySelectorAll('.swiper-button-disabled').length !== 2) {
        arrow.classList.add("customer-wins__slider-nav_active");
      } else {
        arrow.classList.remove("customer-wins__slider-nav_active");
      }
    }

    new Swiper(".customer-wins__slider", {
      slidesPerView: "auto",
      spaceBetween: 10,
      navigation: {
        prevEl: '.customer-wins__slider-nav-prev',
        nextEl: '.customer-wins__slider-nav-next',
      },
      on: {
        resize: function () {
          hideArrow();
        }
      },
      breakpoints: {
        576: {
          spaceBetween: 35,
        },
      },
    });

    activateCompany(companies[0]);
    hideArrow();
  } else if (infoSlides.length) {
    new Swiper(".cases-stadies__slider", {
      slidesPerView: 1,
      autoHeight: true,
      pagination: {
        clickable: true,
        el: ".cases-stadies__slider-nav-pagination",
      }
    });
    document.querySelector(".cases-stadies__slider-nav").classList.add("cases-stadies__slider-nav_active")
  }
};
